import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IS1PaginatedResult, IS1SearchParams, S1HttpClientService } from '@app/s1';
import { IUtente, RuoloUtente } from '../models/utente';
import { Router } from '@angular/router';
import { MenuService } from '@app/core/menu/menu.service';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';

export interface IIdUtente {
  idUtente: string
}

export interface ICreaUtente extends IUtente {
  //password: string,
  //confermaPassword: string
}

export interface IAggiornaUtente extends IUtente { } // E' uguale a IUtente, ma per chiarezza creo interfaccia che si chiama come API
export interface IRicercaUtenti extends IS1SearchParams {
  nomeCompleto?: string,
  codiceRuolo?: string,
  nomeRuolo?: string,
  idRuolo?: string,
  email?: string
}

export interface IUtentiPaginati extends IS1PaginatedResult {
  utenti: IUtente[],
}

export interface IMenuItem {
  text: string,
  icon: string,
  link: string,
  submenu: IMenuItem[]
}

export interface IProfiloUtente {
  utente: IUtente,
  menu : IMenuItem[] | any[],
  profilo: any,
  abilitazioni: string[]
}

export interface ILoginUtenteParams {
  token: string
}

// TODO controllare utente
export enum UtenteAPI {
  utente = "/Utente",
  ricerca = "/Utente/Ricerca",
  getProfilo = "/Utente/Profilo",
  login = "/Utente/Login"
}

@Injectable({
  providedIn: 'root'
})
export class UtenteService {

  private currentUser: IUtente;

  constructor(private router: Router, private s1HttpClient: S1HttpClientService, public menuService: MenuService,  private msalService: MsalService) { }

  getCurrentUser(): Observable<IUtente> {

    return new Observable((observer) => {

      if (this.currentUser) {
        observer.next(this.currentUser)
        observer.complete()
      } else {
        this.getProfilo().subscribe(utente => {
          this.currentUser = utente.utente ?? utente.profilo;
          localStorage.setItem("profilo", JSON.stringify(utente?.profilo));
          const menuStandarized = this.menuService.standardizeMenu((utente.menu as any)?.children);
          localStorage.setItem("menu", JSON.stringify(menuStandarized));
          this.menuService.replaceMenu(menuStandarized);
          localStorage.setItem("abilitazioni",JSON.stringify(utente?.abilitazioni))
          observer.next(this.currentUser);
          observer.complete();
        })
      }
  
    })

  }

  clearCurrentUser() {
    this.currentUser = null;
    localStorage.clear();
  }

  login(params: ILoginUtenteParams): Observable<boolean> {

    return this.s1HttpClient.post(UtenteAPI.login, params).pipe(
      map(response => { 
        localStorage.setItem("token", response.item);
        //localStorage.setItem("idUtente", response.item.idUtente)
        return true 
      })
    )

  }

  logout(logoutReason: number = 0) {

    const azureAccountSt = localStorage.getItem("azureAccount");
    const activeAccount = this.msalService.instance.getActiveAccount();

    if (activeAccount || azureAccountSt) {

      const azureAccount: AccountInfo = JSON.parse(azureAccountSt);

      this.msalService.logoutPopup({
        account: activeAccount ?? azureAccount
      }).subscribe(() => {
        this.clearCurrentUser();
        this.router.navigate(["/login/" + logoutReason]);
      });

    } else {
      this.clearCurrentUser();
      this.router.navigate(["/login/" + logoutReason]);
    }

  }

  isAdmin(): Observable<boolean> {
    return this.checkRuolo(RuoloUtente.SUPERUSER)
  }

  private checkRuolo(ruolo: RuoloUtente): Observable<boolean> {
    return this.getCurrentUser().pipe(
      map(utente => {
        return utente.nomeRuolo === ruolo
      })
    )
  }

  // Utente
  creaUtente(newUtente: ICreaUtente): Observable<IUtente> {

    return this.s1HttpClient.post(UtenteAPI.utente, newUtente).pipe(
      map(response => {
        return response.item
      })
    )

  }

  aggiornaUtente(utenteToUpdate: IAggiornaUtente): Observable<boolean> {

    return this.s1HttpClient.put(`${UtenteAPI.utente}/${utenteToUpdate?.idUtente}`, utenteToUpdate).pipe(
      map(response => {
        return response.outcome.success
      })
    )

  }

  eliminaUtente(utenteToDelete: IUtente): Observable<boolean> {

    return this.s1HttpClient.delete(`${UtenteAPI.utente}/${utenteToDelete?.idUtente}`).pipe(
      map(response => {
        return response.outcome.success
      })
    )

  }

  ricercaUtenti(params: IRicercaUtenti): Observable<IUtentiPaginati> {

    return this.s1HttpClient.post(UtenteAPI.ricerca, params).pipe(
      map(response => {
        return  { 
          utenti: response.results,
          paginationInfo: response.paginationInfo
        }
      })
    )

  }

  private getProfilo(): Observable<IProfiloUtente> {

    return this.s1HttpClient.get(UtenteAPI.getProfilo, false).pipe(
      map(response => {
        return response.item
      })
    )

  }

    // Utente
    validaEmail(email: string): Observable<any> {

      return this.s1HttpClient.post("/Utente/ValidaEmail", {"email": email }).pipe(
        map(response => {
          return response
        })
      )
  
    }

}